import React, {useState, useEffect} from 'react';
import {FormControl, Input} from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import { IconButton } from '@material-ui/core';
import FlipMove from 'react-flip-move';
import Message from './Message.js';
import db from './firebase';
import './App.css';
import firebase from "firebase";

/*
React over Ajax because Ajax is asynchrous and react is realtime, much simpler.

UseState - Sets up a piece of short term memory (contents lost on refresh). A variable in React.
UseEffect - Block of code executed based on a condition.

Functional Based Components - Newer. Javascript function taking in prompts as arguments, returns react element.
Class Based Components - Extension from React.

*/

function App() {

  //Benefit of using State's is that they're mutable.
  const [input, setInput] = useState(''); //Message is initially empty. (Loses value on refresh).
  const [messages, setMessages] = useState([]);/*Defines the messages as objects. */
  //Messages stored as an array.
  const [username, setUsername] = useState(''); //Stores the Username.

  useEffect(() => { //Allows us to run a block of code, once when the app starts, to input the username.
    //Run code.
    //If [] is blank, run once when the app component loads.
    setUsername(prompt("Enter your name")); //Popup prompting an input.
      
  }, [] ) //Condition (map to state variables.)

  useEffect(() => { //Runs once when the app loads [], no dependancies.
    db.collection("messages").orderBy("timestamp","asc").onSnapshot(snapshot => {
      //Listener for changes:
      //Everything needs a key because of flipmove.
      setMessages(snapshot.docs.map(doc => ({id: doc.id, message: doc.data()}))) //Loop through the messages and display them all.
      //Returns the message as an object.
    })
    
  }, [])
  
  const sendMessage = (event) => { //Called everytime the sendMessage button is clicked on,
    event.preventDefault(); //Stops the form from freshing (the default action).
    db.collection("messages").add({ //Adding a message to the firebase database.
      message: input,
      username: username,
      timestamp: firebase.firestore.FieldValue.serverTimestamp() //Creates a universal timestamp.
    })
    //Sends the message to FireBase:
    setInput(''); //Clears the input once it has sent.
  }

  /*
  console.log(input); //Shows the input in the console.
  console.log(messages);
  */

  return ( //JS6 allows HTML and JavaScript in the same block.
    <div className="App">
      <img src="https://facebookbrand.com/wp-content/uploads/2018/09/Header-e1538151782912.png?w=100&h=100" alt="Facebook Messenger Clone"></img>
      <h1>CompAndCode's Facebook Messenger Clone</h1>
      <h2>Welcome {username}</h2>

    <form className="app__form">
      <FormControl className="app__formControl">
        <Input className="app__input" placeholder="Enter a Message:" value = {input /*Maps the value to the state. setInput changes the value as we type*/} onChange={event => setInput(event.target.value)} />
        <IconButton className="app__iconButton" disabled={!input /*Disabled if there's no input */} variant="contained" color="primary" type="submit" onClick = {sendMessage} />
        <SendIcon />
      </FormControl>
    </form>

    <FlipMove>
      {
        //Loops through each message element inside the message's array.
        messages.map(({id, message}) => (//Return the message:
          <Message key={id} username={username} message={message}/>
        ))
      }
    </FlipMove>

    </div>
  );
}

export default App;
